import classNames from 'classnames';
import { forwardRef, useMemo } from 'react';

type TextState = 'default' | 'error' | 'disabled' | 'disabledError';

export interface HelperTextProps extends React.HTMLAttributes<HTMLParagraphElement> {
  error?: boolean;
  disabled?: boolean;
}

/**
 * Display text regarding form specific content.
 */
export const HelperText = forwardRef<HTMLParagraphElement, HelperTextProps>((props, ref) => {
  const { className, children, error, disabled } = props;

  const textState: TextState = useMemo(() => {
    if (error && disabled) return 'disabledError';
    else if (error) return 'error';
    else if (disabled) return 'disabled';
    return 'default';
  }, [disabled, error]);

  return (
    <p
      className={classNames(
        'text-xs font-normal text-left mt-1',
        textState === 'default' && 'text-secondary dark:text-gray-400',
        textState === 'error' && 'text-red-500 dark:text-red-400',
        textState === 'disabled' && 'text-gray-300 dark:text-secondary',
        textState === 'disabledError' && 'text-red-300 dark:text-red-200',
        className,
      )}
    >
      {children}
    </p>
  );
});

export default HelperText;
